module.exports = __webpack_public_path__ + "static/media/bg-profile.984fc2cd.jpg";